import axios from "axios";
import { CURRENT_LANG } from 'src/constants';

const APIURL = process.env.PUBLIC_URL + "/api";

axios.interceptors.request.use((config) => {
    config.headers = getHeaders(config.url);
    return config;
}, error => {
    return Promise.reject(error);
});

const getHeaders = (url = null) => {
    let headers = {
        "credentials": "include",
        "Content-Type": "application/json",
        "headers": "application/json",
    }
    return headers;

}

const getWithParam = (endpoint, body) => {
    const url = `${APIURL}/` + endpoint;
    return axios.get(url, { params: body });
}

const getWithParamBlob = (endpoint, body) => {
    const url = `${APIURL}/` + endpoint;
    return axios.get(url, { params: body, responseType: 'blob' });
}

const get = (endpoint, filter = null) => {
    const url = `${APIURL}/` + endpoint;
    return axios.get(url);
}

const post = (endpoint, data) => {
    const url = `${APIURL}/` + endpoint;
    return axios.post(url, data);
}

const postBlob = (endpoint, data) => {
  const url = `${APIURL}/` + endpoint;
  return axios.post(url, data, { responseType: 'blob' });
};

const postBodyWithParam = (endpoint, body, param) => {
    const url = `${APIURL}/` + endpoint;
    return axios.post(url, body, { params: param });
}

const postWithParam = (endpoint, data) => {
    const url = `${APIURL}/` + endpoint;
    return axios.post(url, null, { params: data });
}

const put = (endpoint, data) => {
    const url = `${APIURL}/` + endpoint;
    return axios.put(url, data);
}

const putBodyWithParam = (endpoint, body, param) => {
    const url = `${APIURL}/` + endpoint;
    return axios.put(url, body, { params: param });
}

const putWithParam = (endpoint, body) => {
    const url = `${APIURL}/` + endpoint;

    return axios.put(url, null, { params: body });
}

const deleteWithParam = (endpoint, body) => {
    const url = `${APIURL}/` + endpoint;

    return axios.delete(url, { data: body });
}

const deleteBodyWithParam = (endpoint, body, param) => {
    const url = `${APIURL}/` + endpoint;
    return axios.delete(url, body, { params: param });
}
// async 
const postAsync = async (endpoint, data) => {
    const url = `${APIURL}/` + endpoint;
    return await axios.post(url, data);
}

export const commonService = {
    getWithParam,
    get,
    post,
    postWithParam,
    postBodyWithParam,
    put,
    putWithParam,
    putBodyWithParam,
    deleteWithParam,
    deleteBodyWithParam,
    postAsync,
    getWithParamBlob,
    postBlob
};
